import { atomWithStorage } from 'jotai/utils';

export const completedToursAtom = atomWithStorage<Record<string, boolean>>('glynt-completed-tours', {});
